import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["billingSelect", "planCard"]

  billingChanged() {
    this.highlightSelectedPlan();
  }

  highlightSelectedPlan() {
    const selectedBilling = this.billingSelectTarget.value;
    
    // Remove highlighting from all plan cards
    this.planCardTargets.forEach(card => {
      card.classList.remove('border-primary');
    })

    // Highlight selected plan card
    if (selectedBilling) {
      const selectedCard = document.querySelector(`[data-billing="${selectedBilling}"] .card`);
      if (selectedCard) { 
        selectedCard.classList.add('border-primary'); 
      }
    }
  }
}
